export default __webpack_public_path__ + "static/media/icon_handyqr-2.c25db9d4.jpg";